/* Il nostro DNA · sections Shopify: titolo che si imprime e timeline con l'anno attivo (da js/dna.js) */
(() => {
  /* incluso da più sections: si inizializza una volta sola */
  if (window.__pqDna) return;
  window.__pqDna = true;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Testata fissa del tema: la barra degli anni e la foto si fermano sotto di essa */
  const hdSel = ($('[data-header-selector]') || {}).dataset?.headerSelector;
  const setHeader = () => {
    const h = hdSel && document.querySelector(hdSel);
    const pos = h ? getComputedStyle(h).position : '';
    document.documentElement.style.setProperty('--pq-dna-header-h', (pos === 'sticky' || pos === 'fixed' ? h.getBoundingClientRect().height : 0) + 'px');
  };
  setHeader(); addEventListener('load', setHeader);
  /* l'altezza della testata può cambiare (layout mobile/desktop, caricamento tardivo): la seguo */
  const hdEl = hdSel && document.querySelector(hdSel);
  if (hdEl && 'ResizeObserver' in window) new ResizeObserver(setHeader).observe(hdEl);
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Titolo: lettere che compaiono scorrendo, come nella landing Personalizzazione */
  const title = $('[data-split]');
  if (title) {
    const label = title.textContent.trim();
    let n = 0;
    title.innerHTML = label.split(' ').map(w =>
      `<span class="w">${[...w].map(c => `<span class="ch${c === '.' ? ' ch--dot' : ''}" style="--i:${n++}">${c}</span>`).join('')}</span>`
    ).join(' ');
    title.style.setProperty('--n', n);
    title.setAttribute('aria-label', label);
  }

  /* Timeline */
  const hist = $('.dn-hist');
  const items = $$('.dn-ms');
  const links = $$('.dn-rail__years a');
  const figs = $$('.dn-hist__media figure');
  const yearEl = $('[data-year]');
  const bar = $('.dn-rail__bar i');
  const railYears = $('.dn-rail__years');
  let cur = -1;
  /* Carosello mobile (sotto 900px, come nel CSS) */
  const list = $('.dn-hist__list');
  const mq = matchMedia('(max-width: 900px)');

  const setActive = i => {
    if (i === cur || i < 0) return;
    cur = i;
    const y = items[i].dataset.y;
    items.forEach((el, k) => el.classList.toggle('is-on', k === i));
    links.forEach(a => a.getAttribute('href') === '#y' + y ? a.setAttribute('aria-current', 'step') : a.removeAttribute('aria-current'));
    const k = items[i].dataset.k || y;   // due tappe nello stesso anno: la foto segue la tappa
    figs.forEach(f => f.classList.toggle('is-on', f.dataset.y === k));
    if (yearEl) yearEl.textContent = y;
    // su mobile l'anno attivo resta visibile nella barra
    const a = links.find(l => l.hasAttribute('aria-current'));
    if (a && railYears.scrollWidth > railYears.clientWidth) {
      railYears.scrollTo({ left: a.offsetLeft - railYears.clientWidth / 2 + a.offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
  };

  const onScroll = () => {
    const vh = innerHeight;
    if (title) {
      const tr = title.getBoundingClientRect();
      title.style.setProperty('--p', reduce ? 1 : Math.min(1, Math.max(0, (vh * .95 - tr.top) / (vh * .5))).toFixed(3));
    }
    if (!hist || !items.length) return;
    if (mq.matches) return;   // su mobile la tappa attiva la decide il carosello (onList)
    // tappa attiva: l'ultima il cui inizio ha superato il 45% dello schermo
    const line = vh * .45;
    let i = 0;
    items.forEach((el, k) => { if (el.getBoundingClientRect().top < line) i = k; });
    setActive(i);
    const hr = hist.getBoundingClientRect();
    const prog = Math.min(1, Math.max(0, (line - hr.top) / Math.max(1, hr.height - vh * .55)));
    if (bar) bar.style.setProperty('--prog', prog.toFixed(3));
  };

  /* Mobile: tappa attiva = card allineata al bordo sinistro del carosello; la barra segue lo scorrimento orizzontale */
  const onList = () => {
    if (!mq.matches || !list || !items.length) return;
    const x0 = list.getBoundingClientRect().left + parseFloat(getComputedStyle(list).paddingLeft);
    let i = 0, best = Infinity;
    items.forEach((el, k) => { const d = Math.abs(el.getBoundingClientRect().left - x0); if (d < best) { best = d; i = k; } });
    setActive(i);
    const max = list.scrollWidth - list.clientWidth;
    if (bar) bar.style.setProperty('--prog', (max > 0 ? list.scrollLeft / max : 0).toFixed(3));
  };

  let raf = 0, rafL = 0;
  addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; onScroll(); }); }, { passive: true });
  if (list) list.addEventListener('scroll', () => { if (!rafL) rafL = requestAnimationFrame(() => { rafL = 0; onList(); }); }, { passive: true });
  // addEventListener('resize', () => { setHeader(); onScroll(); });
  addEventListener('resize', () => { setHeader(); onScroll(); onList(); });
  onScroll(); onList();

  // clic su un anno: scorri alla tappa senza cambiare l'indirizzo
  links.forEach(a => a.addEventListener('click', e => {
    const t = $(a.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    if (mq.matches && list) {
      // mobile: scorro il carosello in orizzontale fino alla tappa
      const dx = t.getBoundingClientRect().left - list.getBoundingClientRect().left - parseFloat(getComputedStyle(list).paddingLeft);
      list.scrollBy({ left: dx, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }));
})();
